export default __webpack_public_path__ + "static/media/default-background.d05b6e4a.png";